<template>
  <div class="img-form-wrapper" :class="{ 'd-flex flex-column': grid }">
    <div class="input-img" :class="{'disabled': disabled}">
      <label>
        <a>
          <div v-if="uploadURL && !isButton" class="file-preview">
            <template v-if="isImage(uploadDetail && uploadDetail.type)">
              <img :src="uploadURL.url || '/static/img/default/camera.svg'" alt="" />
            </template>
            <template v-else>
              <div class="file-icon d-flex flex-column align-items-center justify-content-center">
                <i :class="[getFileIcon(uploadDetail && uploadDetail.type), 'ri-2x']"></i>
                <small class="mt-1">{{ uploadDetail && uploadDetail.name ? uploadDetail.name : 'Uploaded file' }}</small>
              </div>
            </template>
          </div>
          <img v-else :src="'/static/img/default/camera.svg'" alt="" />
          <input
            type="file"
            hidden
            :accept="acceptTypes"
            @change="handleFile($event)"
          />
        </a>
      </label>
      <b-progress :max="100" animated v-if="isUploading">
        <b-progress-bar
          :value="uploadPercentage"
          :label="uploadPercentage + '%'"
        ></b-progress-bar>
      </b-progress>
    </div>
    <div v-if="!hideDesc" class="input-desc">
      <div v-if="!hideLabel">
        <span class="d-block font-weight-bold">{{ $t("hint.upload") }}</span>
        <span class="font-weight-bold font-size-sm">
          {{ $t("hint.max_size") }} {{ limit }} Mb
        </span>
      </div>
      <div
        class="mt-3"
        v-if="uploadDetail && value && !errMessage && error.length === 0"
      >
        <span class="d-block text-muted font-size-sm">
          {{ $t("global.file_name") }}:
          <a :href="value" target="_blank">{{ uploadDetail.name }}</a>
        </span>
        <span class="d-block text-muted font-size-sm">
          {{ $t("global.size") }}: {{ (uploadDetail.size / 1000000).toFixed(2) }} Mb
        </span>
        <span class="d-block text-muted font-size-sm">
          {{ $t("global.type") }}: {{ uploadDetail.type }}
        </span>
        <span
          class="badge badge-danger badge-sm mt-3 pointer"
          @click="$emit('input', null)"
        >
          {{ $t("global.delete") }}
        </span>
      </div>
      <div class="mt-3" v-else-if="error.length > 0">
        <span class="d-block text-danger font-size-sm">{{ error[0] }}</span>
      </div>
      <div class="mt-3" v-else-if="errMessage">
        <span class="d-block text-danger font-size-sm">
          {{ $t("hint.failed_upload") }}
        </span>
        <span class="d-block text-danger font-size-sm">{{ errMessage }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "single-upload-component",
  props: {
    error: { type: Array, default: function () { return []; } },
    value: { required: false },
    hideDesc: { type: Boolean, default: false },
    hideLabel: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    isButton: { type: Boolean, default: false },
    grid: { type: Boolean, default: false },
    limit: { type: Number, default: 10 }, // MB
    accept: {
      type: String,
      default: ".jpg,.jpeg,.png,.kml,.kmz,.zip",
    },
  },
  data: function () {
    return {
      isUploading: false,
      uploadDetail: null,
      uploadPercentage: 0,
      errMessage: null,
      uploadURL: null,
    };
  },
  computed: {
    acceptTypes: function () {
      return this.accept;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler: function (to) {
        if (to) {
          this.uploadURL = Object.assign({}, this.uploadURL, to);
        } else {
          this.uploadURL = null;
        }
      },
    },
  },
  methods: {
    isImage: function (type) {
      return type && type.indexOf("image/") === 0;
    },
    getFileIcon: function (type) {
      if (!type) return "ri-file-line";
      if (type.indexOf("zip") !== -1) return "ri-file-zip-line";
      if (type.indexOf("kml") !== -1 || type.indexOf("kmz") !== -1) return "ri-map-pin-line";
      if (type.indexOf("pdf") !== -1) return "ri-file-pdf-line";
      return "ri-file-line";
    },
    handleFile: function (e) {
      var file = e.target.files[0];
      if (!file) return;

      this.$emit("before-upload", file);

      var fileSizeMB = (file.size / 1000000).toFixed(2);
      if (fileSizeMB > this.limit) {
        this.isUploading = false;
        this.errMessage = "File terlalu besar, maksimal " + this.limit + " MB";
        this.$emit("onError", this.errMessage);
        e.target.value = null;
        return;
      }

      this.uploadPercentage = 0;
      this.isUploading = true;

      var self = this;
      this.$_api
        .fileUpload(file, function (event) {
          self.uploadDetail = file;
          self.uploadPercentage = Math.round((100 * event.loaded) / event.total);
        })
        .then(function (res) {
          self.$emit("input", res);
          self.uploadURL = res;
          self.isUploading = false;
          self.errMessage = null;
          e.target.value = null;
        })
        .catch(function (err) {
          self.$emit("input", null);
          self.isUploading = false;
          self.errMessage =
            (err && err.data && err.data.error_message) || err;
          e.target.value = null;
        });
    },
  },
};
</script>

<style>
.img-form-wrapper {
  margin-bottom: 1.75rem;
  display: flex;
  position: relative;
}

.img-form-wrapper .input-img {
  display: block;
  position: relative;
  width: 158px;
  height: 158px;
  border-radius: 17px;
  border: 2px dashed #e4e6ef;
  padding: 2px;
  cursor: pointer;
}

.img-form-wrapper .input-desc {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 1rem;
  padding: 1rem 0;
}

.img-form-wrapper .input-img img {
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 13px;
  cursor: pointer;
}

.file-icon {
  width: 150px;
  height: 150px;
  border-radius: 13px;
  border: 2px dashed #e4e6ef;
  background-color: #f8f9fa;
  color: #6c757d;
  text-align: center;
  padding: 10px;
}
.file-icon i {
  margin-bottom: 5px;
}
.disabled {
    opacity: 0.6;
    background-color: #f8f9fa; 
    color: #6c757d;
    pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/base/component/single-upload.vue